import { Injectable } from "@angular/core";
import { HarloweSupport, ApiService } from "@harlowe/core";
import { lastValueFrom } from "rxjs";
import { environment } from "../../environments/environment";

export abstract class UtilServiceBase
{
    abstract getFileBlob(file: HarloweSupport.File): Promise<Blob>;
    abstract getSignedFile(file: HarloweSupport.File): Promise<Blob>;
}




@Injectable({providedIn: 'root'})
export class UtilService extends UtilServiceBase
{

    constructor(private _api: ApiService)
    {
        super();
    }


    override getFileBlob(file: HarloweSupport.File): Promise<Blob>
    {
        return lastValueFrom
        (
            this._api.getFileBlob(environment.harlowe.tealhealth.baseUri,"/util/files/"+file.id.toString())
        );
    }

    override getSignedFile(file: HarloweSupport.File): Promise<Blob>
    {
        return lastValueFrom
        (
            this._api.getFileBlob(environment.harlowe.tealhealth.baseUri,"/util/files/signed/"+file.id.toString())
        );
    }

}